import { displayDefaultDateTime } from 'app/shared/util/date-utils';
import { displayPercent } from 'app/shared/util/percent';
import * as _ from 'lodash';

export const versionPlanPeriodYear = [
  { label: 'Phiên bản đầu năm', value: 1 },
  { label: 'Phiên bản điều chỉnh giữa năm', value: 2 },
]

export const displayTable = [
  {
    label: 'Hiển thị theo mục tiêu',
    value: 1,
  },
  {
    label: 'Hiển thị theo mục tiêu/KR',
    value: 2,
  },
];

export const checkInStatus = [
  {
    label: 'Tất cả',
    value: null,
  },
  {
    label: 'Đã hoàn thành check in',
    value: 1,
  },
  {
    label: 'Chưa hoàn thành check in',
    value: 2,
  },
];

export const krCheckInStatus = [
  {
    label: 'Tất cả',
    value: null,
  },
  {
    label: 'KR đã check in',
    value: 1,
  },
  {
    label: 'KR chưa check in',
    value: 2,
  },
];


export const contributionViewType = [
  {
    label: 'Hiển thị theo mục tiêu',
    value: 0,
  },
  {
    label: 'Hiển thị theo mục tiêu/KR',
    value: 1,
  },
];

export const contributionView = [
  {
    label: 'Theo mục tiêu',
    value: 0,
  },
  {
    label: 'Theo lĩnh vực',
    value: 1,
  },
  {
    label: 'Theo dự án',
    value: 2,
  },
  {
    label: 'Theo nhóm công việc',
    value: 3,
  },
];

export const actionsEvaluation = [
  {
    key: 1,
    label: 'Thiết lập cấp đánh giá',
  },
  {
    key: 2,
    label: 'Đánh giá',
  },
  {
    key: 3,
    label: 'Kết quả đánh giá',
  },
];


export const columns = [
  {
    title: 'Tỷ trọng mục tiêu',
    key: 'contribution',
    width: '100px',
    dataIndex: 'contribution',
    render(item) {
      if (item) {
        if (_.isInteger(displayPercent(item ?? 0))) return `${displayPercent(item ?? 0)}%`;
        return `${displayPercent(item ?? 0).toFixed(2)}%`;
      }
    },
  },
  {
    title: 'Tỷ trọng KR',
    key: 'krContribution',
    width: '100px',
    dataIndex: 'krContribution',
    render(item) {
      if (item) {
        if (_.isInteger(displayPercent(item ?? 0))) return `${displayPercent(item ?? 0)}%`;
        return `${displayPercent(item ?? 0).toFixed(2)}%`;
      }
    },
  },
  {
    title: 'PIC',
    key: 'accountableName',
    width: '160px',
    dataIndex: 'accountableName',
  },
  {
    title: 'Thời hạn hoàn thành',
    key: 'dueDate',
    width: '110px',
    dataIndex: 'dueDate',
    defaultShow: true,
    render: item => item && displayDefaultDateTime(item),
  },
  {
    title: 'Tình trạng',
    key: 'status',
    width: '100px',
    defaultShow: true,
    dataIndex: 'status',
  },
  {
    title: 'Ngày hoàn thành',
    key: 'completedOn',
    width: '110px',
    dataIndex: 'completedOn',
    defaultShow: true,
    render: item => displayDefaultDateTime(item),
  },
  {
    title: 'Ngày hoàn thành dự kiến',
    key: 'expectedCompleteOn',
    width: '130px',
    dataIndex: 'expectedCompleteOn',
    render: item => displayDefaultDateTime(item),
  },
];

export const columnsExpand = [
  {
    title: 'Đã hoàn thành',
    key: 'completeNote',
    width: 220,
    dataIndex: 'completeNote',
    defaultShow: true,
  },
  {
    title: 'Lý do (không hoàn thành,tạm dừng,hủy)',
    key: 'unFinishNote',
    width: 220,
    dataIndex: 'unFinishNote',
    defaultShow: true,
  },
  {
    title: 'Đánh giá',
    key: 'rating',
    width: '100px',
    dataIndex: 'rating',
    defaultShow: true,
    render(item) {
      if (item) {
        if (Number.isInteger(displayPercent(item ?? 0))) return `${displayPercent(item ?? 0)}%`;
        return `${displayPercent(item ?? 0).toFixed(2)}%`;
      }
    },
  },
  {
    title: 'Khó khăn & nguyên nhân',
    key: 'issue',
    width: 220,
    dataIndex: 'issue',
    defaultShow: true,
  },
  {
    title: 'Giải pháp & kiến nghị',
    key: 'solution',
    width: 220,
    dataIndex: 'solution',
    defaultShow: true,
  },
  {
    title: 'Tag',
    key: 'tags',
    width: 150,
    dataIndex: 'tags',
  },
  {
    title: 'Tag (plan)',
    key: 'planTags',
    width: 150,
    dataIndex: 'planTag',
  },
];
